import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router-dom';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import {
    CreateVPA as CREATE_VPA,
    GetDetails as SELECT
} from 'Components/Api/UPICollection';
const CustomContainer = HOCLoader(Container);

export const CreateVPA = () => {
    const classes = commonStyle();
    const history = useHistory();

    const [isError, setIsError] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');

    const [FormObj, setFormObj] = useState({
        AccountNumber: '',
        IFSCCode: '',
        MobileNumber: '',
        Address: '',
        City: '',
        State: '',
        Pincode: '',
        MerchantID: '',
        FirmName: '',
        PANNumber: '',
        VPA: ''
    });

    const FormValidationSchema = Yup.object({
        FirmName: Yup.string()
            .min(5, 'FirmName should be minimum 5 digit.')
            .required(PLEASE_PROVIDE_VALID + 'name'),
        PANNumber: Yup.string()
            .length(10, 'Must be 10 alpha numberic')
            .required(PLEASE_PROVIDE_VALID + ' PanNumber'),
        VPA: Yup.string().required(PLEASE_PROVIDE_VALID + 'VPA')
    });

    useEffect(() => {
        selectData();
    }, []);

    const submitHandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);
        setIsError(false);
        setLoadingOpen(true);
        const response = await CREATE_VPA(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        let data = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);
        if (data.Message === 'Ok') {
            history.push('/PaymentGatewayTransaction');
            return;
        }
        if (data.Status !== 'SUCCESS') {
            setSeverity('error');
            setResponseMessage(data.Message);
            setIsError(true);
        }
    };

    const selectData = async () => {
        setLoadingOpen(true);
        const response = await SELECT();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        var data = JSON.parse(response.data);

        setFormObj({
            AccountNumber: data.AccountNumber,
            IFSCCode: data.IFSCCode,
            MobileNumber: data.MobileNumber,
            Address: data.Address,
            City: data.City,
            State: data.State,
            Pincode: data.Pincode,
            FirmName: data.FirmName,
            PANNumber: data.PANNumber
        });

        if (data.Message === 'Merchant exists') {
            history.push('/PaymentGatewayTransaction');
        }
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={FormObj}
            >
                {(formProps) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <h2 className={classes.PaperHead_h2}>
                                            UPI : PartnerDetails
                                        </h2>
                                    </Grid>
                                    <Grid item xs={6}></Grid>
                                </Grid>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="AccountNumber"
                                                name="AccountNumber"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Account Number"
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="IFSCCode"
                                                name="IFSCCode"
                                                type="text"
                                                readOnly={true}
                                                placeholder="IFSC Code"
                                                length={11}
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Mobile Number"
                                                name="MobileNumber"
                                                type="Number"
                                                placeholder="Mobile Number"
                                                readOnly={true}
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Address"
                                                name="Address"
                                                type="text"
                                                placeholder="Address"
                                                readOnly={true}
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="City"
                                                name="City"
                                                type="text"
                                                placeholder="City"
                                                readOnly={true}
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="State"
                                                name="State"
                                                type="text"
                                                placeholder="State"
                                                readOnly={true}
                                                disabled
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="PinCode"
                                                name="Pincode"
                                                type="number"
                                                placeholder="PinCode"
                                                length={6}
                                                readOnly={true}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <h2 className={classes.PaperHead_h2}>
                                        CreateVPA
                                    </h2>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Merchant Name/ Firm Name"
                                                name="FirmName"
                                                type="text"
                                                placeholder="Merchant Name/ Firm Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="PAN Number"
                                                name="PANNumber"
                                                type="text"
                                                placeholder="PAN Number"
                                                length={10}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="VPA"
                                                name="VPA"
                                                type="Text"
                                                placeholder="VPA"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="CreateVPA"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                CreateVPA
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <SecondaryButton
                                                type="reset"
                                                title="Clear"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Clear
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
